export const BOOTCAMP_SUBTOPICS_REQUEST = "BOOTCAMP_SUBTOPICS_REQUEST";
export const BOOTCAMP_SUBTOPICS_SUCCESS = "BOOTCAMP_SUBTOPICS_SUCCESS";
export const  BOOTCAMP_SUBTOPICS_FAILURE = " BOOTCAMP_SUBTOPICS_FAILURE";